import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=72c9ef6b&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=72c9ef6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9ef6b",
  null
  
)

export default component.exports